<div>
  <div class="l-row">
    <div class="l-col--side l-col--sideNavigation l-col--sideLeft"></div>
    <div class="l-col--main">
      <div class="c-article" *ngIf="pageContent">
        <!-- <h1 class="c-article__title" [innerHTML]="pageContent.title"></h1> -->

        <div class="c-article__body">
          <div [innerHTML]="pageContentBody"></div>
        </div>
      </div>
    </div>

    <div class="l-col--side l-col--sideNavigation l-col--sideLeft">
      <!-- <img
        src="https://static.bambora.com/payform/banners/payform_row_single.png"
        alt=""
      /> -->
    </div>
  </div>
</div>
